const getStore = state => state.address || {};

const getAddresses = state => getStore(state).addresses || [];
const getAddressById = (state, id) =>
    (getStore(state).addresses || []).filter(address => address.id === id)[0] || {};
const getBillingAddressById = (state, id) =>
    (getStore(state).billingAddresses || []).filter(address => address.id === id)[0] || {};
const getBillingAddresses = state => getStore(state).billingAddresses || [];
const getMessageType = state => getStore(state).message.messageType;
const getMessageWasShown = state => getStore(state).message.wasShown;

const getAddressBookType = state => getStore(state).addressBookType;
const getDefaultAddress = state =>
    getAddresses(state).find(address => address.defaultAddress) || null;
const getDefaultBillingAddress = state =>
    getBillingAddresses(state).find(address => address.defaultAddress) || null;
const getDefaultAddressId = state => getDefaultAddress(state) && getDefaultAddress(state).id;
const getDefaultBillingAddressId = state =>
    getDefaultBillingAddress(state) && getDefaultBillingAddress(state).id;
const getAddressToRemove = state => getStore(state).addressToRemove;
const getSelectedAddressId = state => getStore(state).selectedAddressId || null;
const getCurrentBillingAddressId = state => getStore(state).currentBillingAddressId || null;
const getCurrentDeliveryAddressId = state => getStore(state).currentDeliveryAddressId || null;
const getNeighborhoodFieldInfo = state => getStore(state).neighborhoodFieldInfo || null;

export default {
    getAddresses,
    getBillingAddresses,
    getMessageType,
    getMessageWasShown,
    getAddressBookType,
    getSelectedAddressId,
    getCurrentBillingAddressId,
    getCurrentDeliveryAddressId,
    getDefaultAddress,
    getDefaultBillingAddress,
    getAddressToRemove,
    getDefaultAddressId,
    getDefaultBillingAddressId,
    getAddressById,
    getBillingAddressById,
    getNeighborhoodFieldInfo,
};
